<template>
  <div style="min-width: 950px">
    <div class="content">
      <div class="left">
        <div
          class="logo"
          @click="goIndex"
          v-if="isSaasProxyUser === 0 || isDyAppOwner === 1"
        >
          <img src="../assets/img/top_logo.png" alt="" />
          <div class="logo-text">影票开放平台</div>
        </div>
        <div v-else class="top-logo">
          <template v-if="platformStr === 'haoyin'">
            <img src="../assets/img/logoProxy.png" alt="" />
            <div class="logo-text">好影影票</div>
          </template>
          <template v-if="platformStr === 'youyv' || platformStr === 'ceshi'">
            <img style="width:32px;height: 32px;" src="../assets/img/logoProxy-yy.png" alt="">
            <div class="top-text">有鱼电影</div>
          </template>
        </div>
        <div class="nav-list">
          <div class="list-text" :class="isActive === 1" @click="goRouter(1)">电影票</div>
          <!--          <div class="list-text" v-if="isSaasProxyUser === 0 || isDyAppOwner === 1" :class="isActive === 2"-->
          <!--            @click="goRouter(2)">品牌商城</div>-->
          <div class="list-text" :class="isActive === 3" @click="goRouter(3)">
            账户中心
          </div>
          <div
            class="list-text"
            v-if="isSaasProxyUser === 0 || isDyAppOwner === 1"
            :class="isActive === 4"
            @click="goRouter(4)"
          >
            开放平台
          </div>
          <div
            class="list-text"
            v-if="isSaasProxyUser === 0 || isDyAppOwner === 1"
            :class="isActive === 5"
            @click="goRouter(5)"
          >
            联系我们
          </div>
          <contact class="top" v-if="isShowContact"></contact>
        </div>
      </div>
      <div class="right" v-if="$store.getters.nickname" v-popover:popover>
        <div class="exportCenter" @click="handleExportCenter">导出中心</div>
        <img src="../assets/img/top_header.png" alt="" />
        <div class="right-text">{{ $store.getters.nickname }}</div>
        <img src="../assets/img/top_icon_arrow_closed.png" alt="" />
        <el-popover placement="bottom" title="" trigger="click" ref="popover" content="">
          <div class="pop-menu">
            <div class="out-login" @click="loginOut">退出</div>
          </div>
        </el-popover>
      </div>
    </div>
    <!-- 好影分销代理tab -->
    <div class="nav-select" v-if="isSaasProxyUser !== 0 && isDyAppOwner !== 1">
      <div class="nav-select-flex">
        <div
          class="nav-select-text"
          v-for="(item, index) in navListHaoYinDaiLi"
          :key="index"
          @click="selectHaoYin(index)"
          :class="isSelect == index ? 'active-select' : ''"
        >
          {{ item.text }}
        </div>
      </div>
    </div>
    <div class="nav-select" v-if="isSaasProxyUser === 0 || isDyAppOwner === 1">
      <div class="nav-select-flex">
        <div
          class="nav-select-text"
          v-for="(item, index) in navList"
          :key="index"
          @click="select(index)"
          :class="isSelect == index ? 'active-select' : ''"
        >
          {{ item.text }}
        </div>
      </div>
      <div v-if="isSelect == 2">
        <div class="select-right" v-if="seatNum > 0 || openAppList.length > 0">
          <div class="select-button" @click="goCred">购买小程序席位</div>
          <div class="select-text">席位剩余：{{ seatNum }}</div>
          <div class="select-mini" v-popover:popoverMini>
            <div class="select-text">
              {{ openAppList.length === 0 ? "待授权" : appName }}
            </div>
            <img src="../assets/img/top_icon_arrow_closed.png" alt="" />
          </div>
          <el-popover
            placement="bottom"
            title=""
            width="300"
            trigger="click"
            ref="popoverMini"
            content=""
          >
            <div class="mini-list">
              <div
                class="list-item"
                :class="miniActive == index ? 'list-item-active' : ''"
                v-for="(item, index) in openAppList"
                :key="index + 'id'"
                @click="changeMini(item, index)"
              >
                <div class="flex">
                  <img class="list-item-img" :src="item.appImg" alt="" />
                  <div class="list-item-text">{{ item.appName }}</div>
                </div>
                <div v-if="miniActive == index">
                  <img src="@/assets/img/switchover_icon_selected.png" alt="" />
                </div>
              </div>
              <div
                class="list-item"
                @click="goAuto(item)"
                v-for="(item, index) in packagePitList"
                :key="index"
              >
                <div class="flex">
                  <img
                    class="list-item-img"
                    src="@/assets/img/switchover_icon_accredit.png"
                    alt=""
                  />
                  <div class="list-item-text">
                    待授权({{
                      item.profitPackageSnapshotId === 0 ? "基础套餐" : "分销套餐"
                    }})
                  </div>
                </div>
                <div class="flex">
                  <div class="flex-text">去授权</div>
                  <img src="@/assets/img/switchover_icon_arrow.png" alt="" />
                </div>
              </div>
            </div>
          </el-popover>
          <a
            class="set-box"
            href="https://www.yuque.com/u32516990/aspkll"
            target="_blank"
          >
            <div><img src="@/assets/img/home_icon_operation.png" alt="" />操作手册</div>
          </a>
        </div>
      </div>
      <div v-if="isSelect == 3">
        <div class="select-right" v-if="seatNum > 0 || openAppList.length > 0">
          <div class="select-button" @click="goCred">购买小程序席位</div>
          <div class="select-text">席位剩余：{{ seatNum }}</div>
          <div class="select-mini" v-popover:popoverMini>
            <div class="select-text">
              {{ openAppList.length === 0 ? "待授权" : appName }}
            </div>
            <img src="../assets/img/top_icon_arrow_closed.png" alt="" />
          </div>
          <el-popover
            placement="bottom"
            title=""
            width="300"
            trigger="click"
            ref="popoverMini"
            content=""
          >
            <div class="mini-list">
              <div
                class="list-item"
                :class="miniActiveZfb == index ? 'list-item-active' : ''"
                v-for="(item, index) in openAppList"
                :key="index + 'id'"
                @click="changeMini(item, index)"
              >
                <div class="flex">
                  <img class="list-item-img" :src="item.appImg" alt="" />
                  <div class="list-item-text">{{ item.appName }}</div>
                </div>
                <div v-if="miniActiveZfb == index">
                  <img src="@/assets/img/switchover_icon_selected.png" alt="" />
                </div>
              </div>
              <div
                class="list-item"
                @click="goAuto(item)"
                v-for="(item, index) in packagePitList"
                :key="index"
              >
                <div class="flex">
                  <img
                    class="list-item-img"
                    src="@/assets/img/switchover_icon_accredit.png"
                    alt=""
                  />
                  <div class="list-item-text">
                    待授权({{
                      item.profitPackageSnapshotId === 0 ? "基础套餐" : "分销套餐"
                    }})
                  </div>
                </div>
                <div class="flex">
                  <div class="flex-text">去授权</div>
                  <img src="@/assets/img/switchover_icon_arrow.png" alt="" />
                </div>
              </div>
            </div>
          </el-popover>
          <a
            class="set-box"
            href="https://www.yuque.com/u32516990/aspkll"
            target="_blank"
          >
            <div><img src="@/assets/img/home_icon_operation.png" alt="" />操作手册</div>
          </a>
        </div>
      </div>
      <div v-if="isSelect== 6">
        <div class="select-right" v-if="seatNum > 0 || openAppList.length > 0">
          <div class="select-button" @click="goCred">购买渠道商城席位</div>
          <div class="select-text">席位剩余：{{ seatNum }}</div>
          <div class="select-mini" v-popover:popoverMini>
            <div class="select-text">
              {{ openAppList.length === 0 ? "待命名" : appName }}
            </div>
            <img src="../assets/img/top_icon_arrow_closed.png" alt="" />
          </div>
          <el-popover
            placement="bottom"
            title=""
            width="300"
            trigger="click"
            ref="popoverMini"
            content=""
          >
            <div class="mini-list">
              <div
                class="list-item"
                :class="miniActiveChannel == index ? 'list-item-active' : ''"
                v-for="(item, index) in openAppList"
                :key="index + 'id'"
                @click="changeMini(item, index)"
              >
                <div class="flex">
                  <img class="list-item-img" :src="item.appImg" alt="" />
                  <div class="list-item-text">{{ item.appName }}</div>
                </div>
                <div v-if="miniActiveChannel == index">
                  <img src="@/assets/img/switchover_icon_selected.png" alt="" />
                </div>
              </div>
              <div
                class="list-item"
                @click="goAuto(item)"
                v-for="(item, index) in packagePitList"
                :key="index"
              >
                <div class="flex">
                  <img
                    class="list-item-img"
                    src="@/assets/img/switchover_icon_accredit.png"
                    alt=""
                  />
                  <div class="list-item-text">
                    待命名({{
                      item.profitPackageSnapshotId === 0 ? "基础套餐" : "分销套餐"
                    }})
                  </div>
                </div>
                <div class="flex">
                  <div class="flex-text">去接入</div>
                  <img src="@/assets/img/switchover_icon_arrow.png" alt="" />
                </div>
              </div>
            </div>
          </el-popover>
          <a
            v-if="isSelect == 6"
            class="set-box"
            href="https://apifox.com/apidoc/shared-a194c212-6a38-45e3-b3e0-ec970864eca6"
            target="_blank"
          >
            <div><img src="@/assets/img/home_icon_operation.png" alt="" />操作手册</div>
          </a>
          <a
            v-else
            class="set-box"
            href="https://www.yuque.com/u32516990/aspkll"
            target="_blank"
          >
            <div><img src="@/assets/img/home_icon_operation.png" alt="" />操作手册</div>
          </a>
        </div>
      </div>
      <div class="nav-right" v-if="isSelect == 1">
        <div class="auth-btn" @click="toAuthorization">添加公众号</div>
        <div class="official-account">
          <div class="official-div">
            <div v-if="platformName">
              <img class="avatar" v-if="headImg" :src="headImg" alt="" />
              <img
                class="avatar"
                v-else
                src="~@/assets/img/official/weishouquan.png"
                alt=""
              />
            </div>
            <div class="account-name">{{ platformName }}</div>
            <span
              @click="changeAccount()"
              class="show-change"
              v-if="publicList.length > 1"
              >切换公众号</span
            >
          </div>
          <div class="official-dialog-box" v-if="isShowAccount">
            <span class="bot"></span>
            <span class="top"></span>
            <div class="official-item">
              <div
                class="official-item-div"
                v-for="(item, index) of publicList"
                :key="index"
              >
                <img v-if="item.headImg" :src="item.headImg" alt="" />
                <img v-else src="~@/assets/img/official/weishouquan.png" alt="" />
                <div class="color-666">{{ item.platformName }}</div>
                <div class="item-change" @click="changePubilc(item)">切换</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Contact from "@/components/Contact";
import mini from "@/api/mini";
import {
  getIsBasic,
  getUserUUID,
  getPlatformName,
  getHeadImg,
  setPlatformUuid,
  setPlatformName,
  setSnapshotId,
  setIsOver,
  setIsBasic,
  setHasPackage,
  setIsAuthOfficial,
  setHeadImg,
} from "@/utils/auth";
const miniModel = new mini();
import official from "@/javaApi/official";
import {mapState} from "vuex";
const officialModel = new official();
export default {
  components: {
    Contact,
  },
  name: "centerNav",
  data() {
    return {
      // 代理域名
      // platformStr:'' || localStorage.getItem('platformStr'),
      isActive: 0,
      navList: [
        {
          text: "我的API",
        },
        {
          text: "我的公众号",
        },
        {
          text: "我的微信小程序",
        },
        {
          text: "我的支付宝小程序",
        },
        {
          text: "我的抖音推广",
        },
        {
          text: "我的快手推广",
        },
        {
          text: "我的H5渠道商城",
        },
      ],
      navListHaoYinDaiLi: [
        {
          text: "我的抖音推广",
        },
        {
          text: "我的快手推广",
        },
      ],
      // isSelect: 2,
      seatNum: "", // 购买的席位
      openAppList: [], // 绑定的小程序
      packagePitList: [], // 席位列表
      miniActive: 0,
      miniActiveZfb: 0,
      miniActiveChannel:0,
      appKey: "",
      appName: "",
      platformName: getPlatformName(),
      headImg: getHeadImg(),
      isShowAccount: false,
      publicList: [],
      userInfo: {},
      isShowContact: false,
    };
  },

  computed: {
    ...mapState({
      // 通过 mapState 从 store 中的 user 模块获取 userInfo
      proxyUrl: (state) => state.user.proxyUrl,
      platformStr:(state) => state.user.platformStr,
    }),
    // 顶部nav的索引，小程序2，支付宝小程序3
    isSelect: {
      get() {
        // return this.$store.getters.selectItem || localStorage.getItem('isSelect')
        console.log(localStorage.getItem("isSelect"), "AAA===1");
        let isSelect = localStorage.getItem("isSelect");
        return isSelect;
      },
      set() {},
    },
    isSaasProxyUser: function () {
      return this.$store.getters.isSaasProxyUser;
    },
    isDyAppOwner: function () {
      return this.$store.getters.isDyAppOwner;
    },
    activeIndex: {
      get: function () {
        return this.$store.getters.activeIndexMini;
      },
      set: function () {},
    },
  },
  mounted() {
    this.getBuySeat();
    this.getHasAuthPubilc();
    // this.isSelect = localStorage.getItem('isSelect')
    if (localStorage.getItem("miniActive")) {
      this.miniActive = localStorage.getItem("miniActive");
      console.log(this.miniActive, "this.miniActive==");
    }
    if (localStorage.getItem("miniActiveZfb")) {
      this.miniActiveZfb = localStorage.getItem("miniActiveZfb");
      console.log(this.miniActiveZfb, "this.miniActiveZfb==");
    }
    if (localStorage.getItem("miniActiveChannel")) {
      this.miniActiveChannel = localStorage.getItem("miniActiveChannel");
      console.log(this.miniActiveChannel, "this.miniActiveChannel==");
    }
  },
  methods: {
    handleExportCenter(){
      this.$router.push({
        path:'/pc/exportCenter/index'
      })
    },
    changeAccount() {
      if (this.isShowAccount === false) {
        this.getHasAuthPubilc();
        this.isShowAccount = true;
      } else {
        this.isShowAccount = false;
      }
    },
    // 跳转
    goRouter(index) {
      console.log('goRoutergoRoutergoRouter')
      this.isActive = index;
      if (index === 1) {
        if (this.isSaasProxyUser === 1 && this.isDyAppOwner == 1) {
          this.$router.push("/pc/douyin/home/index");
          localStorage.setItem("isSelect", 4);
        } else if(this.isSaasProxyUser === 1 && this.isDyAppOwner !== 1) {
          this.$router.push("/pc/douyin/home/index");
          localStorage.setItem("isSelect", 0);
        }else {
          this.$router.push("/pc/home");
        }
      }
      if (index === 2) {
        this.$router.push("/pc/open/home");
      }
      if (index === 3) {
        this.$router.push("/pc/user/accountWithdrawal");
      }
      if (index === 4) {
        this.$router.push("/pc/document/user");
      }
      if (index === 5) {
        this.isShowContact = !this.isShowContact;
      }
    },
    select(index) {
      // this.isSelect = index
      console.log(index, "indexindex===1");
      localStorage.setItem("isSelect", index);
      if (index == 0) {
        this.$router.push("/pc/promotion/home");
      }
      if (index == 1) {
        this.$router.push("/pc/official/statistics");
      }
      if (index == 2) {
        this.$router.push("/pc/miniProgram/home");
      }
      // 支付宝
      if (index == 3) {
        this.$router.push("/pc/zfbMiniProgram/home");
      }
      if (index == 4) {
        this.$router.push("/pc/douyin/home/index");
      }
      if (index == 5) {
        this.$router.push("/pc/kuaishou/home/index");
      }
      if (index == 6) {
        this.$router.push("/pc/channelMiniProgram/home");
      }
      this.$store.commit("nav/SET_SELECT_ITEM", index);
    },
    selectHaoYin(index) {
      console.log('好影'+index)
      localStorage.setItem("isSelect", index);
      if (index == 0) {
        this.$router.push("/pc/douyin/home/index");
      }
      if (index == 1) {
        this.$router.push("/pc/kuaishou/home/index");
      }
      this.$store.commit("nav/SET_SELECT_ITEM", index);
    },
    loginOut() {
      localStorage.removeItem("appKeyMini");
      localStorage.removeItem("appName");
      localStorage.removeItem("nowMini");
      localStorage.removeItem("isMerchant");
      localStorage.removeItem("isAuthorized");
      localStorage.removeItem("isSelect");
      localStorage.removeItem("userInfo");

      localStorage.removeItem("appKeyMiniZfb");
      localStorage.removeItem("appNameZfb");

      this.$store.dispatch("user/logout");
      this.$Message.success("退出成功");
      // 判断是否是代理分销的账户进到制定登录页
      if (this.isSaasProxyUser === 1 && this.isDyAppOwner === 0) {
        this.$router.push({
          path: "/pc/proxyHome/index",
        });
      } else {
        this.$router.push({
          path: "/",
        });
      }
    },
    goIndex() {
      this.$router.push({
        path: "/",
      });
    },
    // 获取购买席位数量
    getBuySeat() {
      console.log(this.isSelect, "this.isSelectthis.isSelect===22");
      let params = {};
      if (this.isSelect == 3) {
        // 支付宝
        params = {
          channelType: 4,
        };
      }
      if (this.isSelect == 2) {
        // 微信
        params = {
          channelType: 0,
        };
      }
      if (this.isSelect == 6) {
        // 渠道商
        params = {
          channelType: 7,
        };
      }
      console.log(params, "paramsparams==");
      miniModel.getMiniNum(params).then((res) => {
        console.log(res, "获取购买席位数量11");
        if (res.data.code == 200) {
          this.seatNum = res.data.data.packagePitList.length;
          this.packagePitList = res.data.data.packagePitList;
          this.openAppList = res.data.data.openAppList;
          // 微信小程序
          if (this.isSelect == 2) {
            if (localStorage.getItem("appName")) {
              this.appName = localStorage.getItem("appName");
            } else {
              if (this.openAppList.length > 0) {
                this.appName = this.openAppList[0].appName;
              }
            }
            if (localStorage.getItem("appId") == null) {
              if (this.openAppList && this.openAppList.length) {
                this.appName = this.openAppList[0].appName;
                this.appKey = this.openAppList[0].appKey;
              }
            } else {
              let appId = localStorage.getItem("appId");
              for (let index in this.openAppList) {
                if (this.openAppList[index].id == appId) {
                  this.appName = this.openAppList[index].appName;
                  this.appKey = this.openAppList[index].appKey;
                  localStorage.setItem("isMerchant", this.openAppList[index].isMerchant);
                  // 微信
                  this.miniActive = index;
                  console.log(index, "index=A");
                  break;
                } else {
                  this.appName = this.openAppList[0].appName;
                  this.appKey = this.openAppList[0].appKey;
                  this.miniActive = 0;
                }
              }
            }
            // 存入缓存后期使用
            if (localStorage.getItem("appKeyMini") == null) {
              localStorage.setItem("appKeyMini", this.appKey);
            }
            console.log("this.appKey", this.appKey);
            if (!localStorage.getItem("pitId")) {
              if (this.packagePitList.length > 0) {
                localStorage.setItem("pitId", this.packagePitList[0].id);
              }
            }
          }
          // 支付宝
          if (this.isSelect == 3) {
            if (localStorage.getItem("appNameZfb")) {
              this.appName = localStorage.getItem("appNameZfb");
            } else {
              if (this.openAppList.length > 0) {
                this.appName = this.openAppList[0].appName;
              }
            }
            if (localStorage.getItem("appIdZfb") == null) {
              if (this.openAppList && this.openAppList.length) {
                this.appName = this.openAppList[0].appName;
                this.appKey = this.openAppList[0].appKey;
              }
            } else {
              let appId = localStorage.getItem("appIdZfb");
              for (let index in this.openAppList) {
                if (this.openAppList[index].id == appId) {
                  this.appName = this.openAppList[index].appName;
                  this.appKey = this.openAppList[index].appKey;
                  localStorage.setItem("isMerchant", this.openAppList[index].isMerchant);
                  this.miniActiveZfb = index;
                  console.log(index, "index=A");
                  break;
                } else {
                  this.appName = this.openAppList[0].appName;
                  this.appKey = this.openAppList[0].appKey;
                  this.miniActiveZfb = 0;
                }
              }
            }
            // // 存入缓存后期使用
            // console.log("this.appKey", this.appKey);
            // if (localStorage.getItem("appKeyMiniZfb") == null) {
            //   localStorage.setItem("appKeyMiniZfb", this.appKey);
            // }
            // 存入缓存后期使用
            if (localStorage.getItem("appKeyMini") == null) {
              localStorage.setItem("appKeyMini", this.appKey);
            }
            // localStorage.setItem("appKeyMini", this.appKey);
            if (!localStorage.getItem("pitIdZfb")) {
              if (this.packagePitList.length > 0) {
                localStorage.setItem("pitIdZfb", this.packagePitList[0].id);
              }
            }
          }
          // 渠道商城
          if (this.isSelect == 6) {
            if (localStorage.getItem("appNameChannel")) {
              this.appName = localStorage.getItem("appNameChannel");
            } else {
              if (this.openAppList.length > 0) {
                this.appName = this.openAppList[0].appName;
              }
            }
            if (localStorage.getItem("appIdChannel") == null) {
              if (this.openAppList && this.openAppList.length) {
                this.appName = this.openAppList[0].appName;
                this.appKey = this.openAppList[0].appKey;
              }
            } else {
              let appId = localStorage.getItem("appIdChannel");
              for (let index in this.openAppList) {
                if (this.openAppList[index].id == appId) {
                  this.appName = this.openAppList[index].appName;
                  this.appKey = this.openAppList[index].appKey;
                  localStorage.setItem("isAuthorized", this.openAppList[index].isAuthorized);
                  this.miniActiveChannel = index;
                  console.log(index, "index=A");
                  break;
                } else {
                  this.appName = this.openAppList[0].appName;
                  this.appKey = this.openAppList[0].appKey;
                  this.miniActiveChannel = 0;
                }
              }
            }
            // 存入缓存后期使用
            if (localStorage.getItem("appKeyMini") == null) {
              localStorage.setItem("appKeyMini", this.appKey);
            }
            // localStorage.setItem("appKeyMini", this.appKey);
            if (!localStorage.getItem("pitIdChannel")) {
              if (this.packagePitList.length > 0) {
                localStorage.setItem("pitIdChannel", this.packagePitList[0].id);
              }
            }
          }
          console.log(this.miniActive, "miniActive====8989");
          console.log(this.miniActiveChannel, "this.miniActiveChannel==8989");
        } else {
          this.$message.error(res.info);
        }
      });
    },
    // 去授权
    goAuto(item) {
      // 微信小程序
      if (this.isSelect == 2) {
        this.$router.push({
          path: "/pc/miniProgram/auto",
          query: {
            isPay: false,
            pitId: item.id,
          },
        });
        localStorage.setItem("pitId", item.id);
      }
      // 支付宝小程序
      if (this.isSelect == 3) {
        this.$router.push({
          path: "/pc/zfbMiniProgram/auto",
          query: {
            isPay: false,
            pitIdZfb: item.id,
          },
        });
        localStorage.setItem("pitIdZfb", item.id);
      }
      // 渠道
      if (this.isSelect == 6) {
        this.$router.push({
          path: "/pc/channelMiniProgram/auto",
          query: {
            isPay: false,
            pitIdZfb: item.id,
          },
        });
        localStorage.setItem("pitIdZfb", item.id);
      }
      console.log(item.id, "去授权==");
    },
    // 选择小程序
    changeMini(item, index) {
      // 微信小程序
      if (this.isSelect == 2) {
        this.miniActive = index;
        this.appKey = item.appKey;
        localStorage.setItem("appKeyMini", this.appKey);
        localStorage.setItem("miniActive", this.miniActive);
        // 其实可以存一个item就可以后期优化（时间不足
        localStorage.setItem("isMerchant", item.isMerchant);
        // miniAppType
        localStorage.setItem("miniAppType", item.miniAppType);
        console.log(
          "debug:________________localStorage.setItem('isMerchant', item.isMerchant)______________",
          localStorage.setItem("isMerchant", item.isMerchant)
        );
        localStorage.setItem("appName", item.appName);
        localStorage.setItem("appId", item.id);
        localStorage.setItem("nowMini", JSON.stringify(item));
        // this.$store.commit('nav/SET_ACTIVE_INDEX_MINI', 0)
        this.appName = item.appName;
        this.$emit("getBuySeatIndex");
        // 清除url参数
        this.$router.push("/pc/miniProgram/home");
        // todo 待优化每次切换小程序刷新页面用来展示新数据
        window.location.reload();
      }
      // 支付宝小程序
      if (this.isSelect == 3) {
        this.miniActiveZfb = index;
        this.appKey = item.appKey;
        // localStorage.setItem("appKeyMiniZfb", this.appKey);
        localStorage.setItem("appKeyMini", this.appKey);
        localStorage.setItem("miniActiveZfb", this.miniActiveZfb);
        // 其实可以存一个item就可以后期优化（时间不足
        localStorage.setItem("isMerchant", item.isMerchant);
        // miniAppType
        localStorage.setItem("miniAppTypeZfb", item.miniAppType);
        console.log(
          "debug:________________localStorage.setItem('isMerchant', item.isMerchant)______________",
          localStorage.setItem("isMerchant", item.isMerchant)
        );
        localStorage.setItem("appNameZfb", item.appName);
        localStorage.setItem("appIdZfb", item.id);
        localStorage.setItem("nowMini", JSON.stringify(item));
        // this.$store.commit('nav/SET_ACTIVE_INDEX_MINI', 0)
        this.appName = item.appName;
        this.$emit("getBuySeatIndex");
        // 清除url参数
        this.$router.push("/pc/zfbMiniProgram/home");
        // todo 待优化每次切换小程序刷新页面用来展示新数据
        window.location.reload();
      }
      if (this.isSelect == 6) {
        this.miniActiveChannel = index;
        this.appKey = item.appKey;
        // localStorage.setItem("appKeyMiniZfb", this.appKey);
        localStorage.setItem("appKeyMini", this.appKey);
        localStorage.setItem("miniActiveChannel", this.miniActiveChannel);
        // 其实可以存一个item就可以后期优化（时间不足
        localStorage.setItem("isAuthorized", item.isAuthorized);
        // miniAppType
        localStorage.setItem("miniAppTypeChannel", item.miniAppType);
        console.log(
          "debug:________________localStorage.setItem('isAuthorized', item.isAuthorized)______________",
          localStorage.setItem("isAuthorized", item.isAuthorized)
        );
        localStorage.setItem("appNameChannel", item.appName);
        localStorage.setItem("appIdChannel", item.id);
        localStorage.setItem("nowMini", JSON.stringify(item));
        // this.$store.commit('nav/SET_ACTIVE_INDEX_MINI', 0)
        this.appName = item.appName;
        this.$emit("getBuySeatIndex");
        // 清除url参数
        this.$router.push("/pc/channelMiniProgram/home");
        // todo 待优化每次切换小程序刷新页面用来展示新数据
        setTimeout(() => {
          window.location.reload();
        },100)
      }
    },
    goCred() {
      if (this.isSelect == 2) {
        this.$router.push("/pc/miniProgram/creditCard");
      }
      if (this.isSelect == 3) {
        this.$router.push("/pc/zfbMiniProgram/creditCard");
      }
      if (this.isSelect == 6) {
        this.$router.push("/pc/channelMiniProgram/creditCard");
      }
    },
    toAuthorization() {
      setPlatformUuid(0);
      setPlatformName("");
      setSnapshotId(-1); //表示新添加的公众号
      setIsOver(1);
      setIsBasic(true);
      setHasPackage(false);
      setIsAuthOfficial(false);
      setHeadImg("");
      this.$store.dispatch("official/changeIsShowSlide", true);
      if (getIsBasic() === "true") {
        this.$store.dispatch("nav/changeOfficialAccountActiveIndex", 5);
      } else {
        this.$store.dispatch("nav/changeOfficialAccountActiveIndex", 8);
      }
      // this.$router.push({
      //   path: '/pc/official/dialog'
      // }).catch(err => { err })
      // window.open('#/pc/official/dialog?is_new=1','_self')
      // this.$router.go(0)
      this.$router
        .push({
          path: "/pc/official/dialog",
          query: { is_new: 1 },
        })
        .catch((err) => {
          err;
        });
    },
    //获取公众号信息
    getHasAuthPubilc() {
      this.listLoading = true;
      officialModel
        .getAuthPublicList({ openUserUuid: getUserUUID() })
        .then((response) => {
          var res = response.data;
          console.log(res, "获取公众号信息");
          if (res.code != 200) {
            this.$Message.error(res.message);
            return;
          }
          this.publicList = res.data.binds;
        })
        .catch((error) => {
          console.log(error);
          if (error != "token invalid") {
            this.$Message.error("系统异常请稍后再试！");
          }
        });
    },
    //切换公众号
    changePubilc(row) {
      var that = this;
      that.$Message.success("公众号切换中...");
      setPlatformUuid(row.platformUuid);
      setPlatformName(row.platformName);
      if (row.snapshotId !== null) {
        setSnapshotId(row.snapshotId);
      } else {
        setSnapshotId(0);
      }
      setIsOver(row.isOver);
      if (row.isProfit === 1) {
        setIsBasic(false);
      } else {
        setIsBasic(true);
      }
      if (row.packageName !== null) {
        setHasPackage(true);
      } else {
        setHasPackage(false);
      }
      if (row.platformUuid !== "" && row.platformName !== "") {
        setIsAuthOfficial(true);
      } else {
        setIsAuthOfficial(false);
      }
      setHeadImg(row.headImg);
      setTimeout(function () {
        that.$router.go(0);
      }, 300);
    },
  },
};
</script>

<style scoped lang="less">
.content {
  height: 64px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  border-bottom: 1px solid #e8e8e8;

  .left {
    display: flex;
    align-items: center;

    .nav-list {
      display: flex;
      align-items: center;
      position: relative;

      .list-text {
        font-size: 14px;
        color: #333333;
        line-height: 20px;
        margin-right: 48px;
        cursor: pointer;
      }

      .active {
        color: #ff8622;
      }
    }

    .logo {
      display: flex;
      align-items: center;
      margin-right: 48px;
      cursor: pointer;

      .logo-text {
        font-size: 18px;
        color: #333333;
        line-height: 25px;
      }

      img {
        margin-right: 8px;
      }
    }
  }

  .right {
    display: flex;
    align-items: center;
    cursor: pointer;

    .exportCenter{
      margin-right: 24px;
    }

    .right-text {
      font-size: 14px;
      color: #333333;
      line-height: 20px;
      margin: 0 8px;
    }
  }

  .top {
    position: absolute;
    right: 0;
    top: 0;
    margin-top: 44px;
  }
}

.nav-select {
  background: #fff;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  position: relative;
  box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.05);

  .nav-select-flex {
    display: flex;
    align-items: center;
  }

  .nav-select-text {
    margin-right: 40px;
    color: #666666;
    line-height: 20px;
    cursor: pointer;
  }

  .select-right {
    display: flex;
    align-items: center;

    .select-button {
      width: 107px;
      height: 28px;
      background: #ff8622;
      border-radius: 2px;
      text-align: center;
      font-size: 12px;
      color: #ffffff;
      line-height: 28px;
      cursor: pointer;
      margin-right: 10px;
    }

    .select-text {
      font-size: 12px;
      color: #666666;
      line-height: 17px;
      margin-right: 10px;
    }
  }
}

.active-select {
  font-weight: bold;
  color: #333333 !important;
  position: relative;

  &:after {
    content: "";
    height: 4px;
    width: 28px;
    background: #ff8622;
    position: absolute;
    left: 30%;
    bottom: -14px;
  }
}


.pop-menu{
  display: flex;
  flex-direction: column;
  .out-login {
    font-size: 14px;
    font-family: FZLTHJW--GB1-0, FZLTHJW--GB1;
    font-weight: normal;
    color: #666666;
    line-height: 17px;
    text-align: center;
    padding: 8px 10px;
    margin: 5px 0;
    cursor: pointer;
    border-right: 8px;
    &:hover{
      background: #ececec;
    }
  }
}


.mini-list {
  max-height: 350px;
  overflow-y: auto;

  &::-webkit-scrollbar-track-piece {
    margin: 8px;
    border-radius: 4px;
  }

  &::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  &::-webkit-scrollbar-thumb {
    background: #eef0f8;
    border-radius: 4px;
  }

  .list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    cursor: pointer;

    .list-item-img {
      width: 28px;
      height: 28px;
      background: #ff7752;
      border-radius: 100%;
      margin-right: 8px;
    }

    .list-item-text {
      color: #333333;
      line-height: 20px;
    }
  }

  .list-item-active {
    background: #fff9f4;
  }
}

.flex {
  display: flex;
  align-items: center;

  .flex-text {
    font-size: 14px;

    color: #ff8622;
    line-height: 20px;
  }
}

.set-box {
  width: 108px;
  height: 28px;
  background: #f0f8ff;
  border-radius: 14px;
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #3d9efc;
  line-height: 28px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  // position: absolute;
  // right: 20px;

  img {
    margin-right: 4px;
  }
}

.select-mini {
  display: flex;
  align-items: center;
  cursor: pointer;
  background: #fafafa;
  border-radius: 14px;
  padding: 6px 10px;
  margin-right: 10px;
}
</style>
<style>
.nav-right {
  float: right;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.nav-right .official-account {
  float: right;
  height: 80px;
  font-size: 16px;
  color: #666666;
  padding-right: 20px;
  display: flex;
  flex-direction: column;
}

.nav-right .official-account .official-div {
  height: 80px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.nav-right .official-account .official-div .show-change {
  color: #3d9efc;
  font-size: 12px;
  cursor: pointer;
}

.nav-right .official-account .avatar {
  width: 32px;
  height: 32px;
  border-radius: 16px;
}

.nav-right .official-account .account-name {
  font-size: 13px;
  color: #666666;
  max-width: 80px;
  margin: 0 5px;
  overflow: hidden;
  white-space: nowrap;
  word-break: break-all;
  text-overflow: clip;
  text-overflow: ellipsis;
}

.nav-right .auth-btn {
  font-family: Alibaba-PuHuiTi-R;
  background: #ff8622;
  border-radius: 2px;
  color: #ffffff;
  padding: 6px 15px;
  cursor: pointer;
  margin-right: 20px;
}

.nav-right .official-account .arrow-img {
  width: 20px;
}

.nav-right .official-account {
  float: right;
  height: 80px;
  font-size: 16px;
  color: #666666;
  padding-right: 20px;
}

.nav-right .official-account .official-div {
  height: 80px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.nav-right .official-account .avatar {
  width: 32px;
  height: 32px;
  border-radius: 16px;
}

.nav-right .official-account .account-name {
  font-size: 13px;
  color: #666666;
  max-width: 80px;
  margin: 0 5px;
  overflow: hidden;
  white-space: nowrap;
  word-break: break-all;
  text-overflow: clip;
  text-overflow: ellipsis;
}

.nav-right .official-account .arrow-img {
  width: 20px;
}

.nav-right .official-dialog-box {
  background: #ffffff;
  width: 160px;
  position: relative;
  top: 8px;
  border-top: 1px solid #eeeeee;
}

.nav-right .official-dialog-box span {
  width: 0;
  height: 0;
  font-size: 0;
  overflow: hidden;
  position: absolute;
}

.nav-right .official-dialog-box .bot {
  border-width: 8px;
  border-style: solid dashed dashed;
  border-color: transparent transparent #eeeeee transparent;
  left: 44%;
  top: -16px;
}

.nav-right .official-dialog-box .top {
  border-width: 8px;
  border-style: solid dashed dashed;
  border-color: transparent transparent #ffffff transparent;
  left: 44%;
  top: -15px;
}

.nav-right .official-dialog-box .official-item {
  position: absolute;
  width: 100%;
  text-align: center;
  font-size: 13px;
  color: #666666;
  line-height: 36px;
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-top: none;
  z-index: 999;
  max-height: 350px;
  overflow-y: auto;

  &::-webkit-scrollbar-track-piece {
    margin: 8px;
    border-radius: 4px;
  }

  &::-webkit-scrollbar {
    width: 7px;
    height: 7px;
  }

  &::-webkit-scrollbar-thumb {
    background: #eef0f8;
    border-radius: 4px;
  }
}

.nav-right .official-dialog-box .official-item .official-item-div {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.nav-right .official-dialog-box .official-item .official-item-div .item-change {
  color: #3d9efc;
  cursor: pointer;
}

.nav-right .official-dialog-box .official-item img {
  height: 30px;
  margin-top: 3px;
}

.nav-right .official-dialog-box .official-item .active {
  background: #fcfaf8;
  color: #ff9734;
}

.logo-text {
  font-size: 18px;
  font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #000000;
  line-height: 25px;
  margin-left: 10px;
}

.top-logo {
  display: flex;
  align-items: center;
  margin-right: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/centerNav.vue